import {IndividualSourceOfFunds, IndividualSourceOfFundsMapping} from "../../resources/application"
import React from "react"
import {Editable, EditableDropDownField} from "../HorizontalField/EditableHorizontalField"

export interface EditableIndividualSourceOfFundsProps {
	sourceOfFunds?: IndividualSourceOfFunds
	setSourceOfFunds: (value: IndividualSourceOfFunds) => void
	isEditing: boolean
	isDisabled: boolean
	isAllowed: boolean
	onStartEdit: () => void
	onCancel: () => void
	update: (value: IndividualSourceOfFunds) => void
	className?: string
}

export function EditableIndividualSourceOfFundsField(props: EditableIndividualSourceOfFundsProps) {
	if (props.sourceOfFunds) {
		return (
			<Editable
				label="Source of Funds"
				isEditing={props.isEditing}
				isDisabled={props.isDisabled}
				isAllowed={props.isAllowed}
				onStartEdit={props.onStartEdit}
				onCancel={props.onCancel}
				setValue={props.setSourceOfFunds}
				value={props.sourceOfFunds}
				initial={props.sourceOfFunds}
				update={props.update}
				className={props.className}
				possibleValues={IndividualSourceOfFundsMapping}
			>
				{EditableDropDownField}
			</Editable>
		)
	}

	return null
}
